import React, { useState, useEffect, useMemo } from 'react';
import CheckboxTree from 'react-checkbox-tree';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import { FormattedMessage, useIntl } from 'react-intl';
import backIcon from '../../../assets/icons/message-manager/back.svg';
import SearchIcon from '../../../assets/icons/table/search.svg';

const SelectDestination = ({ checked, treeData, onCheck }) => {
    const [expanded, setExpanded] = useState(['-1']);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredNodes, setFilteredNodes] = useState(treeData);
    const [searchExpandedKeys, setSearchExpandedKeys] = useState([]);
    const intl = useIntl();
    const t = (id) => intl.formatMessage({ id });

    const handleSearchChange = (e) => {
        const searchTerm = e.target.value;
        setSearchTerm(searchTerm);
        const { filteredNodes, expandedKeys } = filterNodes(treeData, searchTerm);
        setFilteredNodes(filteredNodes);
        setSearchExpandedKeys(expandedKeys);
    };

    const filterNodes = (nodes, searchTerm) => {
        if (searchTerm === '') {
            return { filteredNodes: nodes, expandedKeys: [] };
        }
        const lowerCaseSearchTerm = searchTerm.toLowerCase();
        const expandedKeys = ['-1'];
        const filteredNodes =nodes.length>0 && nodes.reduce((acc, node) => {
            if (node.value === '-1') {
                const { filteredNodes: filteredChildren, expandedKeys: childExpandedKeys } = filterNodes(node.children || [], lowerCaseSearchTerm);
                acc.push({ ...node, children: filteredChildren });
                expandedKeys.push(node.value, ...childExpandedKeys);
            } else if (node.label.toLowerCase().includes(lowerCaseSearchTerm)) {
                acc.push(node);
                if (node.children)
                    expandedKeys.push(node.value);
            } else if (node.children) {
                const { filteredNodes: filteredChildren, expandedKeys: childExpandedKeys } = filterNodes(node.children, lowerCaseSearchTerm);
                if (filteredChildren.length > 0) {
                    acc.push({ ...node, children: filteredChildren });
                    expandedKeys.push(node.value, ...childExpandedKeys);
                }
            }
            return acc;
        }, []);
        return { filteredNodes, expandedKeys };
    };

    const { filteredNodes: memoizedFilteredNodes, expandedKeys: memoizedExpandedKeys } = useMemo(() => filterNodes(treeData, searchTerm), [treeData, searchTerm]);

    useEffect(() => {
        setFilteredNodes(memoizedFilteredNodes);
        setSearchExpandedKeys(memoizedExpandedKeys);
    }, [memoizedFilteredNodes, memoizedExpandedKeys]);


    useEffect(() => {
        setFilteredNodes(treeData);
    }, [treeData]);

    return (
        <div className='mt-4'>
            <div className='row d-flex justify-content-between align-items-center'>
                <label className="font-weight-600 font-size-14 w-50"><FormattedMessage id="SELECT_LOCATION_HINT" />:</label>
                <div id="search" className="form-outline search-container w-25 ms-auto position-relative" style={{ height: 'auto' }}>
                    <input
                        id="searchInput"
                        className="form-control bg-white"
                        type="search"
                        placeholder={t("SEARCH")}
                        value={searchTerm}
                        onChange={handleSearchChange}
                    />
                    <img src={SearchIcon} className="searchIcon position-absolute" alt="Search Icon" style={{ top: '20px' }} />
                </div>
            </div>
            <div className="col-12 col-md-12 mt-3 select-Receivers d-flex justify-content-between">
                <CheckboxTree
                    id='checkboxTree'
                    nodes={filteredNodes}
                    checked={checked}
                    expanded={searchExpandedKeys.length > 0 ? searchExpandedKeys : expanded}
                    onCheck={onCheck}
                    showNodeIcon={false}
                    onExpand={setExpanded}
                    nativeCheckboxes={true}
                    optimisticToggle={true}
                />

            </div>
        </div>
    );
};

export default SelectDestination;